<template>
        <div class="success-page">
                <div class="success-content">
                        <div class="hand-icon">
                                <img src="@/assets/images/content/successRegister.svg" width="140px" alt="successRegister" />
                        </div>
                        <h1>{{ $t('legacy.Аккаунт создан') }}</h1>
                        <p>{{ $t('legacy.Регистрация прошла успешно. Теперь вы можете войти в систему.') }}</p>
                        <button @click="redirectToLogin" class="create-design-btn">{{ $t('legacy.Войти в аккаунт') }}</button>
                </div>
        </div>
</template>

<script>
import { localizedAuthPath } from '@/utils/authRoutes'

export default {
        methods: {
                redirectToLogin() {
                        this.$router.push(localizedAuthPath(this.$route, '/login'))
                },
        },
}
</script>

<style scoped>
/* Импорт шрифта Montserrat */
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

.success-page {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background: linear-gradient(to bottom, #fafafa 0%, #bfcadf 70%);
        font-family: 'Montserrat', Arial, sans-serif;
}

.success-content {
        text-align: center;
        max-width: 400px;
        padding: 40px 20px;
        border-radius: 10px;
}

.hand-icon {
        font-size: 96px;
        margin-bottom: 20px;
}

h1 {
        color: #2f3a4a;
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 28px;
}

p {
        color: #556877;
        font-size: 16px;
        margin-bottom: 30px;
        line-height: 1.4;
}

.create-design-btn {
        width: 100%;
        padding: 14px;
        font-size: 16px;
        background-color: #496782;
        color: white;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: background-color 0.3s;
        box-shadow: -5px -3px 8px 0px #FFFFFF;
}
</style>
